export enum HttpErrors {
    Default = 'There was an issue. Please try again later.',
    DefaultUpload = 'Could not upload file. Please try again later.'
}

export const UPLOAD_FAIL_LEARN_MORE_LINK = 'https://support.insanelyelegant.com/help-center/articles/180/how-to-increase-file-maximum-upload-size';
